module.exports = __webpack_public_path__ + "img/clock.f1e8d783.png";